module.exports = __webpack_public_path__ + "static/img/Milos-Degenek.c1b8545.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Milos-Degenek.jpg
// module id = QD5r
// module chunks = 0